// import { resetRouter } from '@/router'
import { getToken, removeToken } from '@/services/cookie'
import services from '@/services'
// import { message } from 'ant-design-vue'


export default {
  namespaced: true,
  state: {
    timeDifference: 0, // 本地时间与NTP时间的差值（毫秒）
    token: getToken(),
    tokenName: "",
    user: {
      userId: '',
      userName: '',
      deptId: '',
      avatar: '',
      roles: [],
      roleIds: [],
      permissions: []
    }
  },
  getters: {
    getUser(state) {
      return state.user
    },
  },
  mutations: {
    setTimeDifference(state, timeDifference) {
			state.timeDifference = timeDifference
		},
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      // console.log(token)

      state.token = token.tokenValue;
      state.tokenName = token.tokenName;
    }
  },
  actions: {
    timeDifference({ commit, state }) {
      // 获取本地时间与 NTP/服务端时间的差值（毫秒）
      // 使用请求往返时间(RTT)的一半做简单校正，减少网络延迟带来的偏差
      const t0 = Date.now();
      return services.news
        .getAllVisits({})
        .then((res) => {
          const t1 = Date.now();
          const rtt = t1 - t0; // 毫秒
          if (res.code == 200) {
            let serverTs = res.timestamp;
            // 兼容返回为秒的情况（若数值很小，认为是秒级）
            if (typeof serverTs === 'number' && Math.abs(serverTs) < 1e11) {
              serverTs = serverTs * 1000;
            }
            // 估计 server 时间在本地接收到响应时的时间：serverTs + rtt/2
            const serverTimeAtReceipt = serverTs + Math.floor(rtt / 2);
            const timeDifference = serverTimeAtReceipt - t1;
            console.log('timeDifference debug', { serverTs, rtt, serverTimeAtReceipt, timeDifference });
            commit('setTimeDifference', timeDifference);
            return timeDifference;
          }
          return Promise.reject(new Error('getAllVisits failed'));
        })
        .catch((err) => {
          console.warn('timeDifference fetch error', err);
          // 不抛出以免影响页面初始化；仍可上报或重试
          return 0;
        });
    },

    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        // getInfo({ commit }) {
        //   return new Promise((resolve) => {
        let data = {
          userId: "admin",
          userName: "超级管理员",
          deptId: "00000000000000000000",
          avatar: "",
          roles: ["超级管理员"],
          roleIds: []
        };
        commit('setUser', data)
        commit('setToken', 'hasToken')

        resolve(data)
        // services.auth.getUserInfo({
        //   token: state.token
        // }).then(response => {
        //   let data = response.data.data;

        //   if (!data) {
        //     reject('验证失败，请重新登录！')
        //   }
        //   let userRoles = data.roles;
        //   let roleIds = [];
        //   let roles = []
        //   userRoles.forEach((item) => {
        //     roles.push(item.roleName);
        //     roleIds.push(item.roleId);
        //   });
        //   data.roles = roles;
        //   data.roleIds = roleIds;
        //   commit('setUser', data)
        //   resolve(data)
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },
    resetInfo({ commit }) {
      return new Promise(resolve => {
        commit('setUser', {
          userId: "",
          userName: "",
          deptId: "",
          avatar: '',
          roles: [],
          roleIds: [],
          permissions: []
        })
        commit('setToken', "")
        removeToken()
        resolve()
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('setUser', {
          userId: "",
          userName: "",
          deptId: "",
          avatar: '',
          roles: [],
          roleIds: [],
          permissions: []
        })
        commit('setToken', "")
        removeToken()
        // resetRouter()
        resolve()
      })
    },
  }
}
